import { Button } from '@toggle/design-system';
import React from 'react';

import * as S from './WebsiteCard.styles';

interface WebsiteCardProps {
  id: string;
  title: string;
  url: string;
  favicon: string;
  handleRemove?: (id: string) => void;
}

export const WebsiteCard = ({
  id,
  title,
  url,
  favicon,
  handleRemove,
}: WebsiteCardProps) => {
  return (
    <S.CardWrapper>
      <S.Content $onlyUrl={!title}>
        <S.Favicon src={favicon} alt={title} />
        <S.InfoWrapper>
          <S.Title>{title}</S.Title>
          <S.Url>{url}</S.Url>
        </S.InfoWrapper>
      </S.Content>
      <Button
        iconName="Close"
        size="xsmall"
        variant="empty"
        onClick={() => {
          handleRemove?.(id);
        }}
      />
    </S.CardWrapper>
  );
};
